<template>
  <v-flex>
    <v-card flat>
      <v-card-title class="py-2">
        <!-- DATE AND STATUS CHIP -->
        <v-layout align-center row>
          <span class="subtitle font-weight-bold grey--text">
            <v-icon color="grey" class="pr-2" small>event</v-icon>
            {{ bankReconciliation.updated_at | friendlyDate }}
          </span>
          <v-spacer></v-spacer>
          <v-chip>
            <v-icon
              size="14"
              class="pr-1"
              :color="
                statusColor(
                  bankReconciliation
                    ? statusLabel(bankReconciliation.reconciliation_status)
                    : 'Draft'
                )
              "
              >{{
                statusIcon(
                  bankReconciliation
                    ? statusLabel(bankReconciliation.reconciliation_status)
                    : "Draft"
                )
              }}</v-icon
            >
            {{
              bankReconciliation
                ? statusLabel(bankReconciliation.reconciliation_status)
                : "Draft"
            }}
          </v-chip>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <!-- TRANSACTIONS -->
        <v-layout row class="pt-2">
          <span class="py-0"
            >{{
              bankReconciliation.bank_transactions &&
              bankReconciliation.bank_transactions.length
            }}
            Transaction(s)</span
          >
          <v-spacer></v-spacer>
          <strong class="caption grey--text py-0 font-weight-bold"
            >Total:
            {{
              bankReconciliation.currency
                ? inCurrencyFromId(
                    bankReconciliation.currency.id,
                    totalTransactionsAmount
                  )
                : ""
            }}</strong
          >
        </v-layout>

        <v-layout column>
          <v-list dense three-line>
            <template
              v-for="(item, index) in bankReconciliation.bank_transactions"
            >
              <transactionListItem
                class="px-0"
                :key="item.id"
                :transaction="item"
              />
              <v-divider
                v-show="index + 1 < bankReconciliation.bank_transactions.length"
                :key="index + '__'"
              ></v-divider>
            </template>
          </v-list>
        </v-layout>

        <!-- INVOICES -->
        <v-layout row class="pt-2">
          <span class="py-0"
            >{{
              bankReconciliation.bank_invoices &&
              bankReconciliation.bank_invoices.length
            }}
            Invoice(s)</span
          >
          <v-spacer></v-spacer>
          <strong class="caption grey--text py-0 font-weight-bold"
            >Total:
            {{
              bankReconciliation.currency
                ? inCurrencyFromId(
                    bankReconciliation.currency.id,
                    totalInvoicesAmount
                  )
                : ""
            }}</strong
          >
        </v-layout>
        <v-layout column>
          <v-list dense three-line>
            <template v-for="(item, index) in bankReconciliation.bank_invoices">
              <invoiceListItem class="px-0" :key="item.id" :invoice="item" />
              <v-divider
                v-show="index + 1 < bankReconciliation.bank_invoices.length"
                :key="index + '__'"
              ></v-divider>
            </template>
          </v-list>
        </v-layout>

        <v-layout row v-if="showCompanyBalance" justify-center mt-2>
          <span class="caption">
            <v-icon color="blue" size="14" class="pr-1">info</v-icon>
            <span class="pr-2">Remaining amount:</span>
            <v-icon color="success" small class="pr-2"
              >mdi-transfer-right</v-icon
            >
            <strong class="px-2">{{
              bankReconciliation.currency
                ? inCurrencyFromId(
                    bankReconciliation.currency.id,
                    totalRemaining
                  )
                : ""
            }}</strong>
          </span>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
import currency from "../../../mixins/currency.js";
import date from "../../../mixins/date.js";
import filePreviewer from "../../../components/shared/filePreviewer";
import accountingStatus from "../../../mixins/accountingStatus.js";
import transactionListItem from "../transactions/transactionListItem";
import invoiceListItem from "../invoices/invoiceListItem";
import JsonViewer from "vue-json-viewer";

export default {
  name: "reconciliationShow",
  mixins: [accountingStatus, currency, date],
  components: {
    filePreviewer,
    transactionListItem,
    invoiceListItem,
    JsonViewer,
  },
  props: {
    showCompanyBalance: {
      type: Boolean,
      default: true,
    },
    bankReconciliation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      previewer: 0,
      expendedInvoiceId: null,
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
    };
  },
  computed: {
    totalInvoicesAmount() {
      if (!this.bankReconciliation.bank_invoices) return 0;
      var total = 0;
      for (var i = 0; i < this.bankReconciliation.bank_invoices.length; i++)
        total += this.relativeAmount(this.bankReconciliation.bank_invoices[i]);
      return total;
    },
    totalTransactionsAmount() {
      if (!this.bankReconciliation.bank_transactions) return 0;
      var total = 0;
      for (var i = 0; i < this.bankReconciliation.bank_transactions.length; i++)
        total += this.relativeAmount(
          this.bankReconciliation.bank_transactions[i]
        );
      return total;
    },
    totalRemaining() {
      return (this.totalTransactionsAmount - this.totalInvoicesAmount).toFixed(
        2
      );
    },
  },
  methods: {
    toggleInvoice(id) {
      this.expendedInvoiceId = this.expendedInvoiceId === id ? null : id;
    },
    relativeAmount(item) {
      if (item.operation_type == "credit") return item.amount;
      else return -item.amount;
    },
    truncate(input) {
      if (!input) return "";
      if (input.length > 20) return input.substring(0, 20) + "...";
      else return input;
    },
  },
};
</script>
